import PropTypes from 'prop-types'
import React from 'react'
import BreakoutModule from '../BreakoutModule'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BreakoutModuleNarrower = (props) => (
  <BreakoutModule {...props} maxWidths={[600, 688, 688]} />
)

BreakoutModuleNarrower.propTypes = {
  hasBottomBorder: PropTypes.bool,
  hasGradient: PropTypes.bool,
}

BreakoutModuleNarrower.defaultProps = {
  hasBottomBorder: true,
  hasGradient: true,
}

export default BreakoutModuleNarrower
